<template>

  <b-form-group label-for="attachments-input" label-class="mb-0">
    <template #label >
      <label>{{$t($getConst.pages.common.attachments)}}</label>
      <input
        v-if="editable"
        multiple
        @change="selectFile"
        type="file"
        name="file"
        id="file"
        class="input-file"
        accept=".jpeg,.jpg,.png,.pdf,.xlsx,.xls,.dot,.doc,.docx,.eml"
      />
      <label v-if="editable" for="file" class="mb-0 d-inline bg-transparent text-primary p-0 border-0 pl-2" >
        <i :class="$getConst.icons.add"/>
      </label>
    </template>

    <ul v-if="fileInfos.length" class="list-group list-group-flush">
      <li v-for="(file, index) in fileInfos" class="list-group-item px-0 bg-transparent">
        <div class="align-box-row">
          <div class="col-7 mr-md-4 px-3 px-md-4">
            <a v-if="file.content" :download="file.name" :href="file.content" target="_blank" class="font-weight-bold">{{ file.name }} <span class="text-muted">({{formatBytes(file.size)}})</span></a>
            <span v-else class="text-primary font-weight-bold">{{ file.name }} <span class="text-muted">({{formatBytes(file.size)}})</span></span>
          </div>
          <div class="col-4 px-3 px-md-4">
            <div v-if="'percentage' in file && file.percentage !== null" class="progress ml-auto">
              <div class="progress-bar bg-secondary" role="progressbar" :style="'width:'+ file.percentage+'%'" :aria-valuenow="file.percentage" aria-valuemin="0" aria-valuemax="100">
                {{file.percentage}}%
              </div>
            </div>
          </div>
          <div  v-if="editable" class="col-1 px-0 pr-3 pr-md-4 line-height-sm text-center">
            <b-spinner v-if="'isDeleting' in file && file.isDeleting" type="grow" small variant="danger"/>
            <b-link v-else class="text-danger" @click="deleteAttachment(file.id)"><i :class="$getConst.icons.close"/></b-link>
          </div>
        </div>
      </li>
    </ul>

  </b-form-group>

</template>

<script>
  import {deleteAttachment, uploadAttachment} from "../../../api/attachments.api";

  export default {
    name: "Attachments",
    props: {
      scopeId: null,
      // helpCenterId: null,
      entityType:null,
      entityId:null,
      fileInfos: {
        type: Array
      },
      editable: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        attachments: [],

        selectedFiles: undefined,
        progressInfos: []

      }
    },
    methods: {
      selectFile(event) {
        this.progressInfos = [];
        this.selectedFiles = event.target.files;
        for (let i = 0; i < this.selectedFiles.length; i++) {
          this.upload(this.selectedFiles[i]);
        }
      },
      upload(file) {
        if (file.size > 10*1024*1024) {
          this.$snotify.error(
            this.$t(this.$getConst.pages.alerts.too_large_file),
            file.name
          );
        } else {
          const index = this.fileInfos.length;
          this.fileInfos.push({ percentage: 0, name: file.name, size: file.size });
          // uploadAttachment(this.scopeId, this.helpCenterId, file, (event) => {
          uploadAttachment(this.scopeId, this.entityType, this.entityId, file, (event) => {
            this.fileInfos[index].percentage = Math.round(100 * event.loaded / event.total);
          })
            .then((response) => {
              this.fileInfos[index].percentage = null;
              this.fileInfos[index] = (response.data);
            })
            .catch(() => {
              this.fileInfos.splice(index, 1);
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.unknown_error))
            });
        }
      },
      deleteAttachment(fileId) {
        const fileIndex = this.fileInfos.findIndex(file => file.id === fileId);
        this.fileInfos[fileIndex].isDeleting = true;
        // deleteAttachment(this.scopeId, this.helpCenterId, fileId).then(
        deleteAttachment(this.scopeId, this.entityType, this.entityId, fileId).then(
          () => {
            this.fileInfos[fileIndex].isDeleting = false;
            this.fileInfos.splice(fileIndex,1);
          },
          () => {
            this.fileInfos[fileIndex].isDeleting = false;
            this.$snotify.error(this.$t(this.$getConst.pages.alerts.unknown_error))
          }
        )
      },
      formatBytes(a, b = 2) {
        if (0 === a) return "0 Bytes";
        const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
        return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
      }
    }
  }
</script>

<style scoped>
  .custom-attachment-input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  .custom-attachment-input + label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
    cursor: pointer;
  }

  .custom-attachment-input:focus + label,
  .custom-attachment-input + label:hover {
    background-color: red;
  }
</style>
